import { util } from './util';

/**
 * Utility for Session Storage management.
 * Use this for CRUD operations to HTML sessionStorage.
 */
export const sessionStorageUtil = {

    /**
     * Get, Add, Delete a string in sessionStorage
     *
     * @param name Name of sessionStorage item
     * @param value Value of sessionStorage item
     */
    str(name: string, value: string = '') {
        // delete
        if (value === null) {
            sessionStorage.removeItem(name);
            return;
        }
        // get
        if (value === '') {
            return sessionStorage.getItem(name);
        }
        // set
        sessionStorage.setItem(name, value);
    },


    /**
     * Get, Add/Edit, Delete an object or an array of objects in sessionStorage
     *
     * @param name Name of sessionStorage item
     * @param value Value of sessionStorage item
     */
    json(name: string, value: any) {
        // delete
        if (value === null) {
            sessionStorage.removeItem(name);
            return;
        }
        // get
        if (util.isEmptyObject(value)) {
            const str = sessionStorage.getItem(name);
            const obj = JSON.parse(str);
            return obj;
        } else {
            // set
            const str = JSON.stringify(value);
            sessionStorage.setItem(name, str);
        }
    }

};

